/**
 * La marca del policlínico (público, sin token).
 *
 * La usa el login para verse suyo antes de que nadie teclee nada, y la
 * cabecera para el logo y el nombre.
 *
 * Antes había tres funciones —por slug, por dominio y "el principal"— porque
 * el servidor atendía a varios policlínicos y había que decirle a cuál.
 * Atiende a uno: hay una.
 */
import { apiFetch } from "./client";

export interface TenantBranding {
  id: number;
  slug: string;
  nombre_comercial: string;
  /** Eslogan que acompaña al nombre en el login. */
  lema: string | null;
  color_primario: string | null;
  /** Segundo color del logotipo: con él el nombre se escribe como está impreso. */
  color_secundario: string | null;
  has_logo: boolean;
  /** Zona IANA del policlínico. Las horas se pintan en ESTA zona. */
  zona_horaria: string;
  /** Su dominio, si tiene uno propio. Informativo. */
  dominio: string | null;
}

export function getTenantBranding(): Promise<TenantBranding> {
  return apiFetch<TenantBranding>("/v1/policlinico", { auth: false });
}

/** URL del logo (público, no requiere token). */
export function tenantLogoUrl(): string {
  const base = (import.meta.env.VITE_API_BASE_URL ?? "/api") as string;
  return `${base}/v1/policlinico/logo`;
}
